import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import projectReducer from "./reducer/project/ProjectReducer";
import farmReducer from "./reducer/farm/FarmReducer";
import marketplaceReducer from "./reducer/marketplace/MarketplaceReducer";
import reportReducer from "./reducer/report/ReportReducer";
import dashboardReducer from "./reducer/dashboard/DashboardReducer";
import grnReducer from "./reducer/grn/GrnReducer";
import userGuideReducer from "./reducer/user_guide/UserGuideReducer";
import cropManagementReducer from "./reducer/crop_management/CropManagementReducer";
import constructionManagementReducer from "./reducer/construction_management/ConstructionManagementReducer";
import appVersionReducer from "./reducer/app_version/AppVersionReducer";

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...projectReducer,
    ...farmReducer,
    ...marketplaceReducer,
    ...reportReducer,
    ...dashboardReducer,
    ...grnReducer,
    ...userGuideReducer,
    ...cropManagementReducer,
    ...constructionManagementReducer,
    ...appVersionReducer,
});

const alexa_farm_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default alexa_farm_store;